module.exports = __webpack_public_path__ + "static/media/Amputation_on_Foot.eb6282b5.png";